import React from 'react';
import { Trash2, Upload } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';

export function AdminResourcesTab({ 
  resources, 
  uploadDialogOpen, setUploadDialogOpen,
  uploadForm, setUploadForm,
  fileInputRef,
  handleResourceUpload, handleDeleteResource 
}) {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Resource Library
        </h1>
        <Dialog open={uploadDialogOpen} onOpenChange={setUploadDialogOpen}>
          <DialogTrigger asChild>
            <Button className="btn-primary" data-testid="upload-resource-btn">
              <Upload className="w-4 h-4 mr-2" /> Upload Resource
            </Button>
          </DialogTrigger>
          <DialogContent className="bg-[#141417] border-[#27272A]">
            <DialogHeader>
              <DialogTitle className="text-white">Upload Resource</DialogTitle>
            </DialogHeader>
            <form onSubmit={handleResourceUpload} className="space-y-4 mt-4">
              <div>
                <Label className="text-[#A1A1AA]">Title</Label>
                <Input
                  value={uploadForm.title}
                  onChange={(e) => setUploadForm({ ...uploadForm, title: e.target.value })}
                  className="input-dark mt-2"
                  required
                />
              </div>
              <div>
                <Label className="text-[#A1A1AA]">Description</Label>
                <Input
                  value={uploadForm.description}
                  onChange={(e) => setUploadForm({ ...uploadForm, description: e.target.value })}
                  className="input-dark mt-2"
                  required
                />
              </div>
              <div>
                <Label className="text-[#A1A1AA]">Category</Label>
                <Input
                  value={uploadForm.category}
                  onChange={(e) => setUploadForm({ ...uploadForm, category: e.target.value })}
                  placeholder="e.g., Trading Guides"
                  className="input-dark mt-2"
                  required
                />
              </div>
              <div>
                <Label className="text-[#A1A1AA]">PDF File</Label>
                <input
                  type="file"
                  ref={fileInputRef}
                  accept=".pdf"
                  className="block w-full mt-2 text-[#A1A1AA]"
                  required
                />
              </div>
              <Button type="submit" className="btn-primary w-full">
                Upload
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </div>
      
      <div className="bg-[#141417] border border-[#27272A] rounded-md overflow-hidden">
        <table className="data-table">
          <thead>
            <tr className="bg-[#09090B]">
              <th>Title</th>
              <th>Category</th>
              <th>Filename</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {resources.length > 0 ? resources.map(r => (
              <tr key={r.id}>
                <td className="text-white">{r.title}</td>
                <td className="text-[#A1A1AA]">{r.category}</td>
                <td className="text-[#71717A] font-mono text-sm">{r.filename}</td>
                <td>
                  <Button 
                    variant="ghost" 
                    size="sm" 
                    className="text-[#FF3333]"
                    onClick={() => handleDeleteResource(r.id)}
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan={4} className="text-center text-[#71717A] py-8">No resources uploaded yet</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
